import type {
  CmmdBoardTask,
  CmmdMember,
  CmmdProjectAgentMember,
  CmmdProjectMilestone,
  CmmdProjectTaskAssignmentSubject,
  CmmdTaskWorkflow,
  CreateCmmdBoardTaskParams,
  ScopedProjectRef,
  ScopedThreadRef,
} from "@cmmd-forge/contracts";
import type { ProjectTaskCreateTarget } from "./taskViewTypes";
import {
  createAssignmentSubject,
  createTaskWithOptionalAssignment,
} from "./projectTaskCreateAssignment";

export interface ProjectTaskCreateDialogProps {
  readonly open: boolean;
  readonly projectId?: number;
  readonly projectRef?: ScopedProjectRef | null;
  readonly projectTitle: string;
  readonly target: ProjectTaskCreateTarget | null;
  readonly tasks: readonly CmmdBoardTask[];
  readonly members: readonly CmmdMember[];
  readonly agentMembers?: readonly CmmdProjectAgentMember[];
  readonly agentMembersLoading?: boolean;
  readonly agentMembersError?: string | null;
  readonly milestones: readonly CmmdProjectMilestone[];
  readonly creating: boolean;
  readonly workflowLoading?: boolean;
  readonly workflowMutationBlocked?: boolean;
  readonly error: string | null;
  readonly workflow?: CmmdTaskWorkflow | null;
  readonly onOpenChange: (open: boolean) => void;
  readonly onCreate: (
    params: CreateCmmdBoardTaskParams,
    assignment?: CmmdProjectTaskAssignmentSubject,
  ) => Promise<boolean>;
  readonly onProjectLeadThreadReady?: ((threadRef: ScopedThreadRef) => void) | undefined;
  readonly onTaskTreeCommitted?: ((taskIds: readonly number[]) => void) | undefined;
}

export const projectLeadDraftIdentity = (props: ProjectTaskCreateDialogProps) => ({
  projectId: props.projectId ?? 0,
  projectRef: props.projectRef ?? null,
});
export const initialMilestoneId = (target: ProjectTaskCreateTarget | null) =>
  target?.milestoneId ?? null;

export async function submitTaskDraft(input: {
  readonly disabled: boolean;
  readonly params: CreateCmmdBoardTaskParams;
  readonly assignment: string | null;
  readonly createMore: boolean;
  readonly onCreate: ProjectTaskCreateDialogProps["onCreate"];
  readonly onReset: () => void;
  readonly onClose: () => void;
}): Promise<void> {
  if (input.params.title.length === 0 || input.disabled) return;
  const created = await createTaskWithOptionalAssignment(
    input.onCreate,
    input.params,
    createAssignmentSubject(input.assignment),
  );
  if (!created) return;
  if (input.createMore) input.onReset();
  else input.onClose();
}
